export interface DealTrackerLead {
  id: string;
  seller_id: string;
  seller_names: string;
  phone_number?: string | null;
  email?: string | null;
  mailing_address?: string | null;
  property_addresses?: string | null;
  expected_commission?: string | null;
  lead_source: string;
  deal_stage: DealStage;
  notes?: string | null;
  property_id?: string | null;
  created_at: string;
  updated_at: string;
}

export type DealStage = 
  | 'purchase_agreement_signed'
  | 'title_initiated'
  | 'marketing'
  | 'under_contract'
  | 'clear_to_close'
  | 'closed';

export const DEAL_STAGES: { value: DealStage; label: string; color: string }[] = [
  { value: 'purchase_agreement_signed', label: 'Purchase Agreement Signed', color: 'bg-amber-500' },
  { value: 'title_initiated', label: 'Title Initiated', color: 'bg-blue-500' },
  { value: 'marketing', label: 'Marketing', color: 'bg-purple-500' },
  { value: 'under_contract', label: 'Under Contract', color: 'bg-cyan-500' },
  { value: 'clear_to_close', label: 'Clear to Close', color: 'bg-emerald-500' },
  { value: 'closed', label: 'Closed', color: 'bg-green-600' },
];

export const LEAD_SOURCES = [
  'Referral',
  'Zillow',
  'Cold Call',
  'Direct Mail',
  'Facebook Ads',
  'Google Ads',
  'Door Knocking',
  'Driving for Dollars',
  'Other'
] as const;

export type LeadSource = typeof LEAD_SOURCES[number];

export interface DealTask {
  id: string;
  lead_id: string;
  seller_id: string;
  title: string;
  description?: string | null;
  due_date?: string | null;
  due_time?: string | null;
  priority: TaskPriority;
  is_completed: boolean;
  created_at: string;
  updated_at: string;
}

export type TaskPriority = 'low' | 'medium' | 'high' | 'urgent';

export const TASK_PRIORITIES: { value: TaskPriority; label: string; color: string }[] = [
  { value: 'low', label: 'Low', color: 'bg-gray-500' },
  { value: 'medium', label: 'Medium', color: 'bg-blue-500' },
  { value: 'high', label: 'High', color: 'bg-orange-500' },
  { value: 'urgent', label: 'Urgent', color: 'bg-red-500' },
];

export interface DealActivity {
  id: string;
  lead_id: string;
  seller_id: string;
  activity_type: ActivityType;
  title: string;
  activity_date: string;
  activity_time?: string | null;
  duration_minutes?: number | null;
  outcome?: string | null;
  notes?: string | null;
  created_at: string;
}

export type ActivityType = 'phone_call' | 'email' | 'meeting' | 'note' | 'text_message';

export const ACTIVITY_TYPES: { value: ActivityType; label: string; icon: string }[] = [
  { value: 'phone_call', label: 'Phone Call', icon: 'Phone' },
  { value: 'email', label: 'Email', icon: 'Mail' },
  { value: 'meeting', label: 'Meeting', icon: 'Users' },
  { value: 'note', label: 'Note', icon: 'FileText' },
  { value: 'text_message', label: 'Text', icon: 'MessageSquare' },
];

export const ACTIVITY_OUTCOMES = [
  { value: 'successful', label: 'Successful', color: 'bg-green-500' },
  { value: 'no_answer', label: 'No Answer', color: 'bg-gray-500' },
  { value: 'follow_up_needed', label: 'Follow Up Needed', color: 'bg-amber-500' },
  { value: 'cancelled', label: 'Cancelled', color: 'bg-red-500' },
] as const;
